export function isValidUri(candidate: string) {
  try {
    new URL(candidate)
    return true
  } catch (e) {
    return false
  }
}
